import { get } from 'lodash'

export default {
  data() {
    return {
      uploadURL: '/api/DocumentStorages/upload',
      downloadURL: '/api/DocumentStorages/download'
    }
  },
  methods: {
    /**
     *
     * @param id
     * @return {string}
     */
    getDownloadUrl: function (id) {
      return `${this.downloadURL}?id=${id}`
    },
    /**
     *
     * @param id
     * @return {string}
     */
    downloadUrlStatic: function (id) {
      // @todo itt majd mas lesz az url
      return `${this.downloadURL}?id=${id}`
    },
    /**
     * @description get Static image source by config
     * @param path: string
     * @return {string}
     */
    getStaticImageSource: function (path) {
      if (path && !path.startsWith('/')) path = `/${path}`
      const staticHost = get(window, 'CORE.env.staticUrl', '/download')
      return `${staticHost}${path}`
    },
    /**
     * @description get Static image template source
     * @param path: string
     * @return {string}
     */
    getStaticSourceTemplate: function (path) {
      if (path && !path.startsWith('/')) path = `/${path}`
      return `getStaticImageSource('${path}')`
    },
  },
}
